import { IconConfig } from "../types";

export const suitcase: IconConfig = {
  type: 'complex' as const,
  viewBox: "0 0 23 16", // Estimé selon les coordonnées du path
  elements: [
    {
      type: 'g',
      id: "suitcase",
      children: [
        {
          type: 'path',
          d: "M16.66 3.398a.22.22 0 0 1-.234-.2V.214A.19.19 0 0 0 16.241 0H6.948a.19.19 0 0 0-.185.214V3.2c0 .118-.13.182-.251.182H.217A.246.246 0 0 0 0 3.627v3.319c0 .117.1.3.217.3h10.139a.36.36 0 0 0 .273-.3V6.24c0-.118.044-.441.164-.441h1.6c.12 0 .164.323.164.441v.708a.36.36 0 0 0 .272.3h10.143c.121 0 .218-.184.218-.3V3.627a.246.246 0 0 0-.218-.245H16.68Zm-8.4-.016c-.12 0-.045-.064-.045-.182V1.5c0-.118-.075-.054.045-.054h6.674c.12 0 .045-.065.045.054v1.7c0 .117.075.182-.045.182H8.258Zm4.33 7.108c0 .117-.071.139-.19.139h-1.6c-.12 0-.164.052-.164-.065V8.178c0-.117-.153-.448-.272-.448H.217c-.119 0-.217.331-.217.448v7.068a.217.217 0 0 0 .217.215h22.755a.217.217 0 0 0 .218-.214V8.178c0-.117-.1-.448-.218-.448H12.833c-.119 0-.272.331-.272.448v2.386l.027-.074Z"
        }
      ]
    }
  ]
}
